const NotificationObjectClassEnum = Object.freeze({
    INVESTOR: 'INVESTOR',
    ADVISER: 'ADVISER',
    OFFER: 'OFFER',
    PROPOSAL: 'PROPOSAL',
    SHORTLIST: 'SHORTLIST'
});

export default NotificationObjectClassEnum;
